// extracted by mini-css-extract-plugin
export default {"stepsSectionWrapper":"HowItWorks__stepsSectionWrapper-EJik"};